import { PAUserSubTabsType } from "@components/molecules/PriceModeCard/types";

const getLocalizationString = (
  isReceivedRequest: boolean,
  selectedTab: string
) => {
  return {
    unReadSelection: selectedTab,
    selection: isReceivedRequest ? `seller_${selectedTab}` : selectedTab,
    emptyTitle:
      isReceivedRequest && selectedTab === PAUserSubTabsType.InternalRequest
        ? "requestHistory.receivedTab.internalEmpty.title.text"
        : isReceivedRequest
        ? `requestHistory.receivedTab.${selectedTab}Empty.title.text`
        : !isReceivedRequest &&
          selectedTab === PAUserSubTabsType.InternalRequest
        ? "requestHistory.sendTab.internalEmpty.title.text"
        : `requestHistory.sendTab.${selectedTab}Empty.title.text`,
    emptyDescription:
      isReceivedRequest && selectedTab === PAUserSubTabsType.InternalRequest
        ? "requestHistory.receivedTab.internalEmpty.description.text"
        : isReceivedRequest
        ? `requestHistory.receivedTab.${selectedTab}Empty.description.text`
        : !isReceivedRequest &&
          selectedTab === PAUserSubTabsType.InternalRequest
        ? "requestHistory.sendTab.internalEmpty.description.text"
        : `requestHistory.sendTab.${selectedTab}Empty.description.text`,
  };
};

export { getLocalizationString };
